import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Form } from '@angular/forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService {

  className = 'FormValidationService'

  validateEmail = function (control: UntypedFormControl): { [input: string]: boolean } | null {
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*/;
    const str = control.value ? control.value.toUpperCase().replace(/\s/, '') : '';
    const isValid = re.test(str.toLowerCase());
    if (isValid === false && control.value !== null && control.value !== '') {
      return { validateEmail: true };
    }
    else if (isValid === true) {
      return null;
    }
    return null;
  }

  validateOnlyNumber = function (control: UntypedFormControl): { [input: string]: boolean } | null {
    const re = /^(0|[1-9][0-9]*)$/;
    const str = control.value ? control.value.toString().toUpperCase().replace(/\s/, '') : '';
    const isValid = re.test(str.toLowerCase());
    if (isValid === false && control.value !== null && control.value !== '' && control.value !== undefined) {
      return { validateOnlyNumber: true };
    }
    else if (isValid === true) {
      return null;
    }
    return null;
  }
  countCharInString(str, ch) {
    return _.countBy(str)[ch] || 0
  }

  validateDecimalsAndNumber = (control: UntypedFormControl): { [input: string]: boolean } | null => {
    const hasOnePoint = this.countCharInString(control.value, '.') === 1 && this.countCharInString(control.value, ',') === 0;
    const hasOneComma = this.countCharInString(control.value, '.') === 0 && this.countCharInString(control.value, ',') === 1;
    const hasMoreThanTwoDecimals = control.value.split('.').length > 2 || control.value.split(',').length > 2;
    let isValid = true;

    if (!hasOnePoint || !hasOneComma || hasMoreThanTwoDecimals) {
      isValid = false
    }

    if (isValid === false && control.value !== null && control.value !== '' && control.value !== undefined) {
      return { validateDecimalsAndNumber: true };
    }
    else if (isValid === true) {
      return null;
    }
    return null;
  }

  mailMatchValidator(g: UntypedFormGroup) {
    return g.get('email')!.value === g.get('emailConfirm')!.value ? null : { 'mismatch': true };
  }

  compareValues(g: UntypedFormGroup) {

    if (!g.get('minValue') || !g.get('maxValue')) {
      return null;
    } else {

      if (+g.get('minValue')!.value <= +g.get('maxValue')!.value) {
        g.get('minValue')!.setErrors(null)
        g.get('maxValue')!.setErrors(null)
        return null
      } else {
        g.get('minValue')!.setErrors({ 'notValid': true })
        g.get('maxValue')!.setErrors({ 'notValid': true })
        return { 'notValid': true }
      }
    }
  }

  validateAltaBaja(g: UntypedFormGroup) {
    if (!g.get('fecha_baja')!.value) {
      return null
    } else {
      return g.get('fecha_alta')!.value < g.get('fecha_baja')!.value ? null : { 'date_mismatch': true };
    }
  }

  catValidator(g: UntypedFormGroup) {
    if (_.isNull(g.get('roles'))) {
      return null
    } else {
      if (_.some(g.get('roles')!.value, { idTypeRolePk: 5, txtTypeRole: "ROL_AUDITADO" })) {
        return null
      } else {
        return _.isUndefined(g.get('professionalCategoryTypes')!.value) ? { required: true } : null
      }
    }
  }

  validatePattern(regex, errorMsg) {
    return (f: UntypedFormControl) => {
      const str = f.value ? f.value.toString().toUpperCase().replace(/\s/, '') : '';
      const isValid = regex.test(str.toLowerCase());
      if (isValid === false) {
        return { validatePattern: true, message: errorMsg };
      }
      else if (isValid === true) {
        return null;
      }
    }
  }
// Incidencia 91 Estado Resuelta, creada validacion para controlar espacios
  validateSpace = function (control: UntypedFormControl): { [input: string]: boolean } | null {
      const str = control.value ? control.value : '';
      const regex = /\s/g;
      const isValid = !regex.test(str.toLowerCase());
      if (isValid === false) {
        return { validateSpace: true };
      }
      else if (isValid === true) {
        return null;
      }
      return null;
  }

  validateWorksDates = function (control: UntypedFormControl): { [input: string]: boolean } | null {

    let isValid = false;

    if (control.value && control.value.length === 2) {
      isValid = _.every(control.value, (item) => {
        return _.isDate(item);
      });
    }

    const result = isValid ? null : { validateWorksDates: true };

    return result;

  }

  validateAssignedHours = function (control: UntypedFormControl): { [input: string]: boolean } | null {

    const result = _.every(control.value, item => _.get(item, 'hours')) ? null : { validateAssignedHours: true };

    return result;

  }

  validateMaxCoverage = (control: UntypedFormControl) => {
    const selection = control.value;
    let isValid = true;
    let message = 'COVERAGE.VALIDATE_MESSAGE.MAX';
    _.forEach(selection, (s) => {
      const coverage = parseFloat(_.get(s, 'coverage'));
      if (coverage) {
        isValid = coverage <= 100;
      } else {
        isValid = false;
        message = 'COVERAGE.VALIDATE_MESSAGE.INVALID';
      }
      return isValid;
    })
    return isValid ? null : { validateMaxCoverage: true, message };
  }

  validateJobProcess = (control: UntypedFormControl) => {
    const jobProcess = control.value;
    let isValid = true;
    if (!jobProcess || jobProcess && jobProcess.length === 0) {
      isValid = false;
    }
    if (jobProcess) {
      isValid = jobProcess.every(jp => {
        if (Number(jp.coverage) <= 100) {
          return true
        }
        return false;
      });
    }
    return isValid ? null : { validateJobProcess: true };

  }

  validateJobRecommendationProcess = (control: UntypedFormControl) => {
    const jobProcess = control.value;
    let isValid = true;
    _.forEach(jobProcess, jb => {
      const sectors = _.get(jb, 'sectorsRecommendation');
      if (sectors) {
        isValid = _.every(sectors, (s) => {
          const valuation = _.get(s, 'valuation');
          if (!valuation) {
            isValid = false;
          }
          return isValid;
        })
      }
      else {
        isValid = false;
      }
      return isValid;

    })
    return isValid ? null : { validateJobProcess: true };

  }

  validateEmptyArray = (control: UntypedFormControl) => {
    const array = control.value;
    let isValid = true;
    if (array && array.length == 0) {
      isValid = false;
    }

    return isValid ? null : { validateEmptyArray: true };
  }

  validateWeight = (control: UntypedFormControl) => {
    const selection = control.value;
    let isValid = true;
     if((selection <= 100) && selection >=0){
        isValid = true;
      }else{
        isValid = false;
      }
    return isValid ? null : { validateWeight: true};
  }
}
